import { clear } from '../../../helpers/compact';
import commonSlices from './common';

type PrismicSlice = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
};

type Slice = {
  type: string;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type SliceMapper = { [key: string]: (slice: any) => Slice };

const normalizeSlice = (mapper: SliceMapper, slice: PrismicSlice): Slice =>
  clear(mapper[slice?.slice_type]?.(slice));

/**
 * Normalize a list of prismic slices
 *
 * @param mapper Mapper available to transform the slice
 * @param slices List of prismic slices to normalize
 * @return Normalized slices
 */
export const processSlices = (mapper: SliceMapper = commonSlices) => (
  slices: PrismicSlice[]
): Slice[] =>
  slices?.map((slice) => normalizeSlice(mapper, slice))?.filter(Boolean);
